/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { DayChip } from './day-chip.model';

@Component({
	selector: 'tp-day-chip-list',
	templateUrl: './day-chip-list.component.html',
	styleUrls: ['./day-chip-list.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DayChipListComponent {
	@Input({ required: true }) public dayChips!: Observable<DayChip[]>;
	@Input() public disabled = false;
	@Input() public themeType: 'days' | 'schedule' = 'days';
	@Output() public chipClick = new EventEmitter<DayChip>();

	public clickChip(chip: DayChip) {
		if (!this.disabled && !chip.disabled) {
			this.chipClick.emit(chip);
		}
	}
}
